var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMouseLeftClick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ereFTOJIGB41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 405 405",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 405,
    height: 405,
    rx: 0,
    ry: 0,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 404.97879 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.656082,202.806884c0-111.349357,90.3232-201.542336,201.833324-201.542336s201.833324,90.192979,201.833324,201.542336-90.3232,201.542335-201.833324,201.542335-201.833324-90.192979-201.833324-201.542335Z",
    fill: "#dc9b3b"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M206.911253,35.449736c-54.992243,0-110.659216,28.803801-110.659216,83.861758v140.246436c0,61.955771,48.309168,112.356996,107.695292,112.356996c59.385219,0,107.694386-50.401225,107.694386-112.356996v-140.246436c0-57.620811-54.285858-83.861758-104.730462-83.861758ZM291.371799,259.55793c0,50.297427-39.219316,91.206845-87.42447,91.206845-48.206964,0-87.422662-40.909418-87.422662-91.206845v-65.593402c18.101918,5.71358,52.173937,14.357079,92.455093,14.357079c25.790757,0,54.114914-3.594224,82.392039-13.745617v64.98194Zm0-87.478628c-73.879235,29.471878-152.269027,7.280921-174.847132-.343476v-52.424332c0-40.733905,46.569885-62.71255,90.386586-62.71255c42.040336,0,84.460546,19.388426,84.460546,62.71255v52.767808ZM215.349891,81.110247v76.666706c0,5.838136-4.543117,10.576019-10.13541,10.576019-5.594103,0-10.136315-4.737883-10.136315-10.576019v-76.666706c0-5.837192,4.541308-10.575076,10.136315-10.575076c5.591389,0,10.13541,4.737884,10.13541,10.575076Zm66.368577,77.365923c0,0-42.226656,12.334915-56.58862,9.691854v-97.815914c0,0,67.568798.882279,56.58862,88.12406Z",
    fill: "#fff",
    stroke: "#dadada"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouseLeftClick);
export default __webpack_public_path__ + "static/media/mouse-left-click.5b05a1ff2c06024ea29244e83c7fb8b1.svg";
export { ForwardRef as ReactComponent };